import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
const initialState = {
  emailSendingAppId: null,
  embedId: '',
  emptyStateName: null,
  isSimpleConfigPanel: false,
  sourceApp: SourceApps.WORKFLOWS_APP
};
export default function embedReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_UNIQUE_EMBED_ID:
      {
        return Object.assign({}, state, {
          embedId: action.uniqueId
        });
      }
    case ActionTypes.SET_SOURCE_APP:
      {
        const sourceApp = action.sourceApp;
        if (!sourceApp) {
          return state;
        }
        return Object.assign({}, state, {
          sourceApp
        });
      }
    case ActionTypes.SET_EMAIL_SENDING_APP_ID:
      {
        const emailSendingAppId = action.emailSendingAppId;
        if (!emailSendingAppId) {
          return state;
        }
        return Object.assign({}, state, {
          emailSendingAppId
        });
      }
    case ActionTypes.SET_EMPTY_STATE_NAME:
      {
        return Object.assign({}, state, {
          emptyStateName: action.emptyStateName
        });
      }
    case ActionTypes.SET_IS_SIMPLE_CONFIG_PANEL:
      {
        return Object.assign({}, state, {
          isSimpleConfigPanel: action.isSimpleConfigPanel
        });
      }
    default:
      return state;
  }
}